var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16.0710678 14.6568542 6.363961-6.36396098c.3905243-.39052429 1.0236893-.39052429 1.4142136 0s.3905243 1.02368927 0 1.41421356l-6.363961 6.36396102 6.363961 6.363961c.3905243.3905243.3905243 1.0236893 0 1.4142136s-1.0236893.3905243-1.4142136 0l-6.363961-6.363961-6.36396102 6.363961c-.39052429.3905243-1.02368927.3905243-1.41421356 0s-.39052429-1.0236893 0-1.4142136l6.36396098-6.363961-6.36396098-6.36396102c-.39052429-.39052429-.39052429-1.02368927 0-1.41421356s1.02368927-.39052429 1.41421356 0z","fill":"#42484d"}));
}

Cross.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = Cross;

Cross.default = Cross;
